import {
  arrayOf as arrayType,
  params,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';

export const collectionModel = {
  collection: params({ collectionId: stringType().isRequired() }).shape({
    metadata: shapeType({
      name: stringType(),
      brandName: stringType(),
      canonicalUrl: stringType(),
      type: stringType()
    }),
    taxonomy: shapeType({
      breadCrumbs: arrayType(shapeType({
        label: stringType()
      }))
    })
  })
};